import { useMemo } from 'react';
import { Star } from 'react-feather';
import type { TaggedMoment } from '@/types/transcribe.rich-text';
import { cx } from '@trinity/chat-components';
import styles from './style/TagBadge.module.css';
import { assertIsGoodQuoteTag, computeTranscriptColor } from './utils';

type Props = {
  className?: string;
  tag: Pick<TaggedMoment, 'color' | 'name' | 'typeId'>;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'style'>;

export const TagBadge = ({ tag, className, ...rest }: Props) => {

  const isGoodQuoteTag = useMemo(() => {
    return assertIsGoodQuoteTag({
      name: tag.name,
      typeId: tag.typeId,
    });
  }, [tag.typeId, tag.name]);

  return (
    <div
      className={cx(styles.tag, rest.onClick ? styles.clickable : null, className)}
      style={{
        backgroundColor: computeTranscriptColor({ color: tag.color, opacity: 10 }),
        borderColor: computeTranscriptColor({ color: tag.color, opacity: 40 }),
      }}
      {...rest}>
      {isGoodQuoteTag && <Star className={styles.star} />}
      {tag.name}
    </div>
  );
};